/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Filename1Inputs */

const en__field_filename1 = /** @type {(inputs: _Field_Filename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const de__field_filename1 = /** @type {(inputs: _Field_Filename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname`)
};

/**
* | output |
* | --- |
* | "Filename" |
*
* @param {_Field_Filename1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_filename1 = /** @type {((inputs?: _Field_Filename1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Filename1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_filename1(inputs)
	return de__field_filename1(inputs)
});
export { _field_filename1 as "_field_fileName" }